import { observer } from 'mobx-react-lite'
import { useLocalNumbersStepsContext } from 'pages/settings/pages/compliance/pages/localNumbers/context/localNumbersStepsContext'
import { LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers/route/type'
import { CommonOptInOnlineFormContent } from 'pages/settings/pages/compliance/ui/CommonOptInContent/ui/CommonOptInOnlineFormContent'
import { RegistrationErrorAlert } from 'pages/settings/pages/compliance/pages/localNumbers/ui/RegistrationErrorAlert/RegistrationErrorAlert'
import { usePathSegment } from 'pages/settings/pages/compliance/hooks/usePathSegment'
import { AiCheckerNextButtons } from 'pages/settings/pages/compliance/ui/AiCheckerNextButton/AiCheckerNextButtons'

export const OptInOnlineFormContent = observer(() => {
  const {
    optInConsentStore,
    stepLoading,
    aiSidebarStore: {
      isAiCheckrWillUse,
      isLoading: aiLoading,
      isSuccessButton,
      isErrorButton,
      isContinueWithIssues,
    },
  } = useLocalNumbersStepsContext()
  const {
    getOptInImagesAsAttach,
    deleteAttachment,
    clearAttachmentError,
    getOptInAttachmentError,
    campaignOptInContentNextClick,
    uploadOptInImageAttachment,
    isOnlineFormNextDisabled,
    commonOptInConsentStore,
  } = optInConsentStore

  const lastPathSegment = usePathSegment<LocalNumbersRoutes>()

  return (
    <CommonOptInOnlineFormContent
      stepLoading={stepLoading}
      getOptInImagesAsAttach={() =>
        getOptInImagesAsAttach(LocalNumbersRoutes.optInOnlineFormContent)
      }
      deleteAttachment={(url: string) =>
        deleteAttachment(url, LocalNumbersRoutes.optInOnlineFormContent)
      }
      uploadAttachment={(attachments: File[]) =>
        uploadOptInImageAttachment(attachments, lastPathSegment)
      }
      increaseStep={() => campaignOptInContentNextClick(lastPathSegment)}
      clearAttachmentError={() => clearAttachmentError(lastPathSegment)}
      isOnlineFormNextDisabled={isOnlineFormNextDisabled}
      getAttachmentError={() => getOptInAttachmentError(lastPathSegment)}
      optInConsentStore={commonOptInConsentStore}
      errorBanner={<RegistrationErrorAlert />}
      aiCheckrButton={
        isAiCheckrWillUse && (
          <AiCheckerNextButtons
            loading={aiLoading}
            disabled={isOnlineFormNextDisabled || aiLoading}
            text='Check and continue'
            onClick={() => campaignOptInContentNextClick(lastPathSegment, true)}
            icon='stars'
            isSuccess={isSuccessButton}
            isError={isErrorButton}
            isContinueWithIssues={isContinueWithIssues}
            onContinueWithIssuesClick={() => campaignOptInContentNextClick(lastPathSegment)}
            isContinueWithIssuesLoading={stepLoading}
          />
        )
      }
    />
  )
})
